import { makeStyles } from '@material-ui/core'

export const useTextInputStyles = makeStyles(() => ({
	textField: {
		width: '100%'
	}
}))

export default useTextInputStyles
